module.exports = "data:image/png;base64,NDA0OiBOb3QgRm91bmQ="